// extracted by mini-css-extract-plugin
export default {"root":"side-panel-section_root__zUUp5","content":"side-panel-section_content__lWiKd"};